<nav class="menu"
     role="menubar">
    <section [attr.aria-label]="'MENU.PRODUCT_MENU_SECTION' | translate">
    @for (link of productMenu; track link.id) {
            @if(link?.children?.length > 0) {
            <button type="button"
            [title]="link?.title"
            [class.selected]="selected===link"
            (click)="open(link)">{{ link.title }}</button>
        } @else {
                <a  [class.selected]="selected===link" [title]="link?.title" [routerLink]="link.link">{{ link.title }}</a>
            }
        }
    </section>
    <section [attr.aria-label]="'MENU.CONTENT_MENU_SECTION' | translate">
        @for (link of contentMenu; track link.id) {
            @if(link?.children?.length > 0) {
            <button type="button"
            [title]="link?.title"
            [class.selected]="selected===link"
            (click)="open(link)">{{ link.title }}</button>
            } @else {
                <a  [class.selected]="selected===link" [title]="link?.title" [routerLink]="link.link">{{ link.title }}</a>
            }
        }
    </section>
</nav>
<dialog id="menu-dialog"
        [modal]="isModal()"
        blurOrBlurWithin
        [attr.animation]="animation"
        (blurOrBlurWithin)="$event.close()"
        (closedEvent)="selected = null"
        >
    <button type="button"
            closeDialog
            class="close">
    </button>


    @for (link of productMenu; track link.id) {
        <app-recursive-link [link]="link"
                            [attr.open]="link==selected ? '' : null"
                            [selected]="selected"
                            (select)="open($event)"></app-recursive-link>
    }
    @for (link of contentMenu; track link.id) {
        <app-recursive-link [link]="link"
                            [attr.open]="link==selected ? '' : null"
                            [selected]="selected"
                            (select)="open($event)"></app-recursive-link>
    }


</dialog>

